// Wing changelog — bump APP_VERSION on every meaningful deploy so users get
// a one-time "Wat is er nieuw?" modal confirming the new build is live.
//
// Tone of voice: short, scannable, benefit-driven. Users do NOT read paragraphs.
// Max 2-3 items per release. Max ~8 words per item.
// Never expose internal terms (WhatsApp, RBAC, Capacitor, MFA, etc).
//
// Format:
//   {
//     version: "1.x.y",
//     date:    "8 mei 2026",
//     title:   "Korte highlight",
//     items:   ["bullet 1", "bullet 2", ...],
//   }
//
// Most recent entry sits at index 0.
export const APP_VERSION = "3.42.0";

export const CHANGELOG = [
    {
        version: "3.42.0",
        date: "16 mei 2026",
        title: "Smart Grocery · WYNG-brand PDF share",
        items: [
            "Jumbo verwijderd uit prijsvergelijking — geen onbetrouwbare data meer.",
            "Nieuwe knop: 'Deel als PDF' op elke boodschappenlijst.",
            "Genereert een WYNG-branded PDF met product iconen + prijzen (indicatief, op basis van AH).",
            "Deel via WhatsApp, mail, of sla op je telefoon — kies zelf je supermarkt.",
        ],
    },
    {
        version: "3.41.0",
        date: "16 mei 2026",
        title: "v1-cleanup · 3 features in de koelkast",
        items: [
            "Rescue Ride tijdelijk verborgen — code bewaard in _archive/.",
            "Future You tijdelijk verborgen — komt later terug.",
            "Theme switcher gepauzeerd — app draait nu vast op Obsidian Gold.",
        ],
    },
    {
        version: "3.40.1",
        date: "16 mei 2026",
        title: "Sync confidence · WHOOP-stijl freshness",
        items: [
            "Live sync banner toont nu hoe lang geleden je laatste sync was ('3 min geleden').",
            "Per-source ledger uit je Health Sources OAuth & Apple Health REST upload.",
        ],
    },
    {
        version: "3.40.0",
        date: "16 mei 2026",
        title: "Battle integriteit · alleen auto-sync",
        items: [
            "Handmatig waarden invullen in een battle is uitgeschakeld.",
            "Resultaten komen alleen nog uit Apple Health, Garmin, Whoop en andere verbonden bronnen.",
            "Live sync-banner toont welke bronnen actief je data aanleveren.",
            "Geen bron verbonden? Duidelijke waarschuwing met 1-tap connect-CTA.",
        ],
    },
    {
        version: "3.39.4",
        date: "16 mei 2026",
        title: "Map fixes · AI Twin naast je",
        items: [
            "AI Twin staat nu écht naast je locatie, niet meer in Amsterdam.",
            "Heroes spawnen binnen 5 km van jou — niet meer op vaste anchors.",
            "Tier label op de Twin-pin heet nu 'AI Twin'.",
            "Andere users tonen pas vanaf neighborhood-zoom (12+), niet bij wereldview.",
            "Navigatie-icoon zonder 'NAV'-tekst — schoner.",
        ],
    },
    {
        version: "3.39.3",
        date: "16 mei 2026",
        title: "AI Twin op de kaart · Snapchat-style",
        items: [
            "Twin bitmoji staat nu losstaand naast je op de kaart — geen frame, geen ring, gewoon je AI Twin.",
            "Subtiel zwevend (3px bob) met blauwe glow. Tap → battle starten.",
            "Nieuwe gendered cartoon renders (man/vrouw) met WYNG-outfit.",
        ],
    },
    {
        version: "3.39.2",
        date: "16 mei 2026",
        title: "Battle hero · Cinematic depth",
        items: [
            "Scroll-parallax op het poster: Twin drijft trager dan de rest mee — Apple-feel.",
            "Breathing aura over de Twin — subtiele puls in elektrisch blauw.",
        ],
    },
    {
        version: "3.39.1",
        date: "16 mei 2026",
        title: "Battle hero · Cinematic poster",
        items: [
            "Bovenaan de battle pagina staat nu het volle handshake-poster (man of vrouw).",
            "DAY X OF 7 + LVL pill + status strip strak overlay'd zonder de art te overlappen.",
        ],
    },
    {
        version: "3.39.0",
        date: "16 mei 2026",
        title: "Battle pagina · Nieuwe AI Twin Console",
        items: [
            "Volledig herontworpen battle pagina — cinematic Twin hero in goud + elektrisch blauw.",
            "7-daagse battle: één winnaar op zondag. +200 Wings + Trophy + Streak.",
            "AI Suggest kiest jouw 3 sterkste strijdmetrics — één tap accepteren.",
            "JIJ vs AI TWIN duel-kaarten + week-grafiek + strateeg-tip in één scherm.",
        ],
    },
    {
        version: "3.38.0",
        date: "16 mei 2026",
        title: "Jouw AI Twin — nu in beeld",
        items: [
            "Neon AI Twin verschijnt op je Shadow-pagina (man of vrouw).",
            "Tik op je Twin op de Crew Map om de battle direct te starten.",
            "Dashboard-tegel toont 'm ook — geen generiek icoontje meer.",
        ],
    },
    {
        version: "3.37.0",
        date: "15 mei 2026",
        title: "Hall of Heroes — je trofeeënkast",
        items: [
            "Elke verslagen Hero komt in je persoonlijke kast te staan.",
            "Datum, defeat-count en elite-trofeeën in één overzicht.",
            "Deel-knop met native share + screenshot-friendly layout.",
        ],
    },
    {
        version: "3.36.0",
        date: "15 mei 2026",
        title: "Shadow Sprint — Avatar, Heroes, Wings",
        items: [
            "Avatar Studio nu ook bereikbaar vanuit Settings.",
            "Hero Battles — daag elke kaartheld 24u uit voor cosmetics.",
            "Wings-saldo zichtbaar bovenaan dashboard.",
            "Je Shadow stuurt om 09:00 een nudge — alleen als je 'm nodig hebt.",
        ],
    },
    {
        version: "3.35.1",
        date: "13 mei 2026",
        title: "Share Recap deelbaar + crash-fix",
        items: [
            "Rescue Ride completion opent de Share Recap (GIF + MP4 9:16).",
            "Hooks-order bug in bottom-nav verholpen — geen crashes meer.",
        ],
    },
    {
        version: "3.35.0",
        date: "12 mei 2026",
        title: "Coach merkt het op",
        items: [
            "Open de chat en Wing stelt automatisch passende aanpassingen voor.",
            "Werkt voor afval-doelen, intensieve workouts en hoge stappen.",
            "Eén tap accepteren, of negeren — 14 dagen geen herhaling.",
        ],
    },
    {
        version: "3.34.0",
        date: "12 mei 2026",
        title: "AI Coach stelt voor",
        items: [
            "De Coach merkt op wanneer je doel verschuift en stelt aanpassingen voor.",
            "Eén tap om macro's/metrics aan je dashboard te plakken.",
            "Coach kan ook Voeding aan je bottom-nav toevoegen als 5e slot.",
            "Alle wijzigingen vereisen jouw expliciete bevestiging.",
        ],
    },
    {
        version: "3.33.0",
        date: "12 mei 2026",
        title: "Nutrition opt-in",
        items: [
            "Onboarding vraagt nu of je voeding wil tracken.",
            "Kies 'Nee' en je dashboard blijft schoon — geen kcal/macro-tiles.",
            "Later van gedachten veranderd? Activeer Voeding via Coach → Tools.",
        ],
    },
    {
        version: "3.32.0",
        date: "12 mei 2026",
        title: "Multi-invite vanaf de Map",
        items: [
            "Houd een pin ingedrukt om iemand aan je challenge-basket toe te voegen.",
            "Selecteer tot 10 crew-leden tegelijk voor één groepschallenge.",
            "Yellow ring + floating CTA toont je selectie onderaan de kaart.",
            "Tik 'Daag uit' om direct naar de challenge-wizard te springen.",
        ],
    },
    {
        version: "3.31.0",
        date: "12 mei 2026",
        title: "Bitmoji + Rescue Ride fixes",
        items: [
            "Jouw JIJ-pin op de kaart is nu een bitmoji.",
            "Rescue Ride start direct met route en coach in beeld.",
            "Coach beweegt vloeiend over de route — geen statische pin meer.",
            "ETA-label gelabeld i.p.v. een blote tellersconde.",
        ],
    },
    {
        version: "3.30.2",
        date: "12 mei 2026",
        title: "Geen magnetische aantrekking meer",
        items: [
            "Kaart blijft staan waar je hem achterlaat — geen auto-recenter naar jezelf.",
            "Vrij in/uitzoomen en pannen, ook als je locatie blijft updaten.",
        ],
    },
    {
        version: "3.30.1",
        date: "12 mei 2026",
        title: "Pinch & pan werken weer",
        items: [
            "Je kunt nu vrij in- en uitzoomen op de kaart.",
            "Vegen in elke richting werkt — ook over de header en crew-strip.",
            "iOS Safari probeert niet meer de pagina te zoomen ipv de kaart.",
        ],
    },
    {
        version: "3.30.0",
        date: "12 mei 2026",
        title: "Map werkt altijd",
        items: [
            "Kaart laadt nu binnen 3 seconden, ook zonder locatie-toestemming.",
            "Geen eindeloze 'Vrienden laden…' meer — duidelijke empty-state.",
            "Dashboard-teller en kaart tonen exact dezelfde crew.",
            "Vriendelijke banner als locatie geblokkeerd is, geen blokkerend scherm.",
        ],
    },
    {
        version: "3.29.1",
        date: "12 mei 2026",
        title: "Responsive bottom-sheets fix",
        items: [
            "Challenge-uitnodiging vanaf de kaart toont nu alle knoppen netjes op mobiel.",
            "Nav-balk verdwijnt automatisch zodra een bottom-sheet opent.",
            "Sheets blijven binnen de 430px app-shell op alle schermbreedtes.",
        ],
    },
    {
        version: "3.29.0",
        date: "12 mei 2026",
        title: "Pins met persoonlijkheid",
        items: [
            "Geen foto? Je krijgt automatisch een WYNG bitmoji-avatar.",
            "Streak van 7+ dagen → vurige ring rond je pin op de kaart.",
            "Zoom in tot straatniveau om namen onder pins te zien.",
        ],
    },
    {
        version: "3.28.0",
        date: "12 mei 2026",
        title: "Snap-stijl progressive map",
        items: [
            "Op de Aarde-view zie je alleen jezelf — geen rij avatars meer.",
            "Zoom in: heatmap toont waar crew-activiteit borrelt.",
            "Verder zoomen: individuele pins verschijnen voor stad-niveau.",
        ],
    },
    {
        version: "3.27.0",
        date: "12 mei 2026",
        title: "Eindig met een medaille",
        items: [
            "Direct na het lanceren van een challenge kun je een 3D-medaille koppelen.",
            "1v1 = 3 credits · Group = €9,99 standard / €29,99 landmark.",
            "Winnaars krijgen automatisch goud/zilver/brons op hun profiel.",
        ],
    },
    {
        version: "3.26.0",
        date: "12 mei 2026",
        title: "Coach Hub: Inbox + Tools",
        items: [
            "Coach heeft nu 4 tabs: Chat · Inbox · Daily · Tools.",
            "Inbox: alle challenge-invites + vriendverzoeken op 1 plek.",
            "Voeding & Grocery zijn opt-in modules onder Tools.",
            "Account toont je actieve challenges met progress-bars.",
            "1 gratis challenge per week · daarna 1 credit per invite.",
        ],
    },
    {
        version: "3.25.0",
        date: "12 mei 2026",
        title: "Earn your rescue — share na de workout",
        items: [
            "+75 XP en share-kaart pas vrij ná een gelogde workout (tot middernacht).",
            "Geen wearable? 2× per maand zelf-declareren voor je share-kaart.",
            "Comeback streak 3× = +150 XP bonus + speciale badge.",
        ],
    },
    {
        version: "3.24.0",
        date: "12 mei 2026",
        title: "Live activiteit op de WYNGX kaart",
        items: [
            "Tik op je eigen pin → 'Wat doe je nu?' (🏃 🏀 🚴 🏋️ 🧘 …).",
            "Bewegende emoji naast je avatar voor je crew.",
            "Verdwijnt automatisch na 30/60/90/120 minuten.",
        ],
    },
    {
        version: "3.23.0",
        date: "12 mei 2026",
        title: "WYNG City — ontdek, volg & daag uit",
        items: [
            "Zet je zichtbaarheid: vrienden, +vrienden van vrienden, of iedereen binnen jouw radius.",
            "Tik op een onbekende pin → 1-tap volgen of challenge sturen.",
            "Vrij format: 'X dagen Y doen' — bv. 7 dagen 10.000 stappen.",
        ],
    },
    {
        version: "3.22.0",
        date: "12 mei 2026",
        title: "Soepelere kaart & sneller dashboard",
        items: [
            "WYNG City zoomt vloeiend in en uit, pins flikkeren niet meer.",
            "Pijltjes terug naar vorige week zijn altijd zichtbaar.",
            "Activity-ringen instellen werkt nu met één tik (geen 'opslaan' meer).",
        ],
    },
    {
        version: "3.21.0",
        date: "12 mei 2026",
        title: "Rescue Ride — echte stratenkaart",
        items: [
            "Zoe of Jaden rijdt over jouw stad — echte Mapbox-route.",
            "Cinematische soundtrack en TTS-stem van je coach.",
            "+75 XP wordt vrijgegeven zodra je vandaag een workout logt.",
        ],
    },
    {
        version: "3.20.0",
        date: "11 mei 2026",
        title: "WYNG MAP — Snap-stijl crew kaart",
        items: [
            "Zie je vrienden op een echte kaart, met FutureYou pin op je doel-locatie.",
            "Tijdelijke Ghost Mode: verberg je locatie voor 1, 4 of 24 uur.",
            "Story streaks — opeenvolgende dagen die je crew samen aantikt.",
        ],
    },
    {
        version: "3.19.0",
        date: "11 mei 2026",
        title: "Friend Witness",
        items: [
            "Nodig tot 3 vrienden uit als getuigen op je badge.",
            "Zij zien je voortgang en kunnen je 🪶 cheeren.",
            "Cheeren = +5 XP voor jou, +1 XP voor de badge-eigenaar.",
        ],
    },
    {
        version: "3.18.0",
        date: "11 mei 2026",
        title: "Maak je eigen badge",
        items: [
            "Schrijf je doel — AI vertaalt het naar meetbare regels.",
            "Kies een NL landmark of standard template als voorkant.",
            "Scratch card reveal direct na betaling.",
        ],
    },
    {
        version: "3.17.0",
        date: "11 mei 2026",
        title: "Nieuwe iconen & medaille stempel",
        items: [
            "Nieuwe favicon, PWA-iconen en home-screen icoon (gouden WYNG).",
            "Achterop elke 3D-medaille staat nu het echte WYNG logo i.p.v. tekst.",
            "Gegraveerd in dezelfde warme goud-tint voor maximale herkenning.",
        ],
    },
    {
        version: "3.16.0",
        date: "11 mei 2026",
        title: "Officiële rebrand naar WYNG",
        items: [
            "Nieuw gouden WYNG-vleugel logo door de hele app.",
            "Welcome, Login, Register, manifest en e-mails — allemaal WYNG.",
            "Privacydocument, push notifications & abonnementen herbrand.",
        ],
    },
    {
        version: "3.15.0",
        date: "10 mei 2026",
        title: "XP & Wings groeien live",
        items: [
            "Verdien XP voor login, AI Coach, maaltijd loggen & meer.",
            "Mini '+15 XP' toasts vieren elke micro-actie.",
            "Recente XP feed onderin de Wings Shop.",
        ],
    },
    {
        version: "3.14.0",
        date: "10 mei 2026",
        title: "Wings Shop",
        items: [
            "Geef Wings uit aan exclusieve themes & badge skins.",
            "Pak partner-aanbiedingen van Decathlon, XXL Nutrition, Nike & meer.",
            "Sovereign? Solar flare wing-glow ontgrendelen.",
        ],
    },
    {
        version: "3.13.0",
        date: "10 mei 2026",
        title: "De Tweede WYNG",
        items: [
            "Verdien je tweede wing met 30 dagen momentum ≥ 40.",
            "Ceremoniële unlock: 'Je bent niet langer aan het worden. Je BENT.'",
            "Wings + tier zichtbaar in de top-bar.",
        ],
    },
    {
        version: "3.12.1",
        date: "10 mei 2026",
        title: "Themes overal door + Momentum nieuw",
        items: [
            "Obsidian Gold & Neon Rose verschijnen nu in heel WYNG.",
            "Momentum tiers in het Nederlands: Aan het opwarmen, Volle vlam…",
            "Glow en kleuren schakelen mee met je gekozen energy.",
        ],
    },
    {
        version: "3.12.0",
        date: "10 mei 2026",
        title: "Choose your WYNG energy",
        items: [
            "Twee themes: Obsidian Gold & Neon Rose.",
            "Wissel in Settings → WYNG energy.",
            "Smooth cross-fade, geen reload.",
        ],
    },
    {
        version: "3.11.1",
        date: "10 mei 2026",
        title: "Smart Grocery — match-quality",
        items: [
            "Boodschappen worden correct herkend, ook met hoeveelheden.",
            "Geen 'Lurpak Smeerbaar' meer als je 'Broccoli' zoekt.",
        ],
    },
    {
        version: "3.11.0",
        date: "10 mei 2026",
        title: "Smart Grocery — Phase 1",
        items: [
            "Boodschappenlijst met live AH + Jumbo prijzen (NL).",
            "Smart Save: AI verdeelt slim, bespaart per week.",
            "AI weekplan: 7 dagen maaltijden + lijst in één klik.",
            "Andere landen: waitlist met preview van features.",
        ],
    },
    {
        version: "3.10.4",
        date: "10 mei 2026",
        title: "Drie fixes",
        items: [
            "Witte error-pop-up op iPhone Safari opgelost.",
            "Pauze houdt nu echt de medaille stil (geen reset).",
            "Stappen kan nu gekozen worden voor de Exercise-ring.",
        ],
    },
    {
        version: "3.10.3",
        date: "10 mei 2026",
        title: "Voelbare medailles",
        items: [
            "Lichte tik bij elke kwartslag terwijl je 'm draait.",
            "Maakt de 3D medaille fysiek aanvoelend op iPhone.",
        ],
    },
    {
        version: "3.10.2",
        date: "10 mei 2026",
        title: "Cleanere medaille-achterkant + langere GIF",
        items: [
            "Geen rechthoekige plaat meer achter het schild.",
            "GIF maakt nu een volledige 360° rotatie in 2 sec.",
            "Hogere resolutie en strakkere kleuren bij delen.",
        ],
    },
    {
        version: "3.10.1",
        date: "10 mei 2026",
        title: "NIEUW-markering op medailles",
        items: [
            "Rode dots verschijnen op badges die je nog niet hebt geopend.",
            "NIEUW-pill op de Medailles sectie telt onverkende badges.",
            "Markeert auto als 'gezien' zodra je de 3D detail opent.",
        ],
    },
    {
        version: "3.10.0",
        date: "10 mei 2026",
        title: "Medailles op je dashboard",
        items: [
            "Top 3 medailles direct zichtbaar op je dashboard.",
            "Tap door naar je volledige collectie en de 3D-versies.",
            "Verbergen of weer terugzetten via één tap.",
            "Demo accounts hebben alle 8 badges al unlocked.",
        ],
    },
    {
        version: "3.9.1",
        date: "10 mei 2026",
        title: "Deel je medaille als GIF",
        items: [
            "Tap 'Deel als GIF' — krijg een geanimeerde share-card.",
            "Gegraveerde achterkant toont nu je voornaam.",
            "Werkt naadloos in WhatsApp, iMessage en Instagram.",
        ],
    },
    {
        version: "3.9.0",
        date: "10 mei 2026",
        title: "3D Achievement Medals",
        items: [
            "Verzamel cinematic 3D medailles voor je mijlpalen.",
            "Polished gold + neon ribbons + gegraveerde achterkant.",
            "Sleep om te draaien, tap om te bewonderen.",
            "Eerste 8 badges live: Crews, Consistency, Milestones, Nutrition.",
        ],
    },
    {
        version: "3.8.0",
        date: "9 mei 2026",
        title: "Crews — alles automatisch",
        items: [
            "Auto-story: elke avond een recap-card voor je crew.",
            "Team streak telt door zolang 50% rings sluit.",
            "Crew Challenges: deelt metric, target en deadline.",
            "Eén tap stuurt een nudge naar al je crewleden.",
        ],
    },
    {
        version: "3.7.0",
        date: "9 mei 2026",
        title: "WYNG Story — Crews",
        items: [
            "Maak een crew met je vrienden of familie.",
            "AI maakt een neon recap-card voor jullie groep.",
            "Eén tap om naar WhatsApp / iMessage te delen.",
            "Jij kiest welke metrics je deelt — niets standaard.",
        ],
    },
    {
        version: "3.6.0",
        date: "9 mei 2026",
        title: "No Guessing — AI Fridge",
        items: [
            "Eén foto van je koelkast, 3 macro-fit recepten.",
            "WYNG legt uit waarom elk recept vandaag past.",
            "Tap om gekozen recept te loggen in voeding.",
        ],
    },
    {
        version: "3.5.0",
        date: "13 feb 2026",
        title: "Future You — Becoming",
        items: [
            "Cinematic transformatie tijdlijn live.",
            "Day 1 vs Today drag-slider met privacy-blur.",
            "Maandelijkse checkpoints met AI inzichten.",
            "Veilig: alleen gestileerde versie opgeslagen, gezicht geblurd.",
        ],
    },
    {
        version: "3.4.0",
        date: "13 feb 2026",
        title: "Smart Dashboard + Coaching toon",
        items: [
            "Onboarding stelt nu écht je dashboard in op basis van je doel.",
            "Fat loss → kcal-tekort, protein, fiber, weight als primary tiles.",
            "AI Coach krijgt 3 tonen: Strict / Supportive / Data-driven.",
            "Wijzig coaching toon via Instellingen → Coaching tone.",
        ],
    },
    {
        version: "3.3.1",
        date: "13 feb 2026",
        title: "Persoonlijk dashboard",
        items: [
            "Dashboard respecteert je Privacy preferences.",
            "Verberg tegels via metric info modal of Privacy & data.",
            "Nieuwe \"+ Voeg toe\" knop om verborgen tegels terug te halen.",
        ],
    },
    {
        version: "3.3.0",
        date: "13 feb 2026",
        title: "AVG-proof Privacy & Data Center",
        items: [
            "Compleet nieuw scherm onder Instellingen → Privacy & data.",
            "Coaching Intelligence Level: Basic → Enhanced → Advanced → Elite.",
            "Per metric: AI gebruiken & dashboard tonen los toggelen.",
            "Privacy modes: Minimaal / Gebalanceerd / Volledig coaching.",
            "Granulair verwijderen + JSON/CSV/PDF export.",
        ],
    },
    {
        version: "3.2.3",
        date: "12 feb 2026",
        title: "Onboarding fix op iPhone Safari",
        items: [
            "Vraag-bubbles waren afgesneden achter de header.",
            "Layout nu gecentreerd op tablet en desktop (max 448px).",
            "Keyboard-detectie krimpt scherm correct, anders 100dvh.",
        ],
    },
    {
        version: "3.2.2",
        date: "12 feb 2026",
        title: "Rondleiding scrollt nu mee",
        items: [
            "Spotlight scrollt automatisch naar elke nieuwe stap.",
            "Geen verwarrend leeg scherm meer tussen stappen.",
        ],
    },
    {
        version: "3.2.1",
        date: "12 feb 2026",
        title: "Drie demo-profielen toegevoegd",
        items: [
            "Athlete, Beginner en Pro accounts voor live demo's.",
            "Elk profiel met eigen 30-dagen health-data verhaal.",
            "Login: athlete@/beginner@/pro@demo.wing.app.",
        ],
    },
    {
        version: "3.2.0",
        date: "12 feb 2026",
        title: "Demo loop voor walkthroughs",
        items: [
            "Demo-accounts doorlopen elke login opnieuw de hele welkomstflow.",
            "Geïmporteerde data en stats blijven netjes bestaan.",
            "\"Sla demo over\" knop voor snelle live demo's.",
        ],
    },
    {
        version: "3.1.1",
        date: "12 feb 2026",
        title: "Rondleidingen op aanvraag",
        items: [
            "Nieuw scherm: Instellingen → Rondleidingen.",
            "Speel elke feature-tour zo vaak af als je wilt.",
            "Reset alles om de welkomsttour automatisch terug te krijgen.",
        ],
    },
    {
        version: "3.1.0",
        date: "12 feb 2026",
        title: "Premium discovery tour",
        items: [
            "Korte spotlight-rondleiding bij eerste login.",
            "Contextuele tips wanneer ze er echt toe doen.",
            "Opnieuw afspelen via Instellingen → Rondleiding.",
        ],
    },
    {
        version: "3.0.0",
        date: "8 mei 2026",
        title: "Subscription model live",
        items: [
            "3 dagen gratis trial met volledige toegang voor nieuwe accounts.",
            "WYNG Pro €7,99/mnd en WYNG Elite €14,99/mnd, ook jaarlijks.",
            "Veilig betalen via Stripe, op elk moment opzegbaar.",
        ],
    },
    {
        version: "2.7.0",
        date: "8 mei 2026",
        title: "Snellere modals en kleine fixes",
        items: [
            "Tile info-modal opent nu in een fractie van een seconde.",
            "Future You opent weer betrouwbaar.",
            "Wheel-titel hernoemd naar 'Rewards' om verwarring met Momentum te voorkomen.",
        ],
    },
    {
        version: "2.6.0",
        date: "8 mei 2026",
        title: "Momentum laadt razendsnel",
        items: [
            "Score verschijnt nu in een paar honderd milliseconden i.p.v. 5–8 seconden.",
            "Direct het juiste frame zichtbaar, data fade't soepel in.",
        ],
    },
    {
        version: "2.5.0",
        date: "8 mei 2026",
        title: "Volledig update-overzicht",
        items: [
            "Nieuw 'What's new' menu in Instellingen.",
            "Filter updates per maand en zie hoe actief WYNG groeit.",
        ],
    },
    {
        version: "2.4.0",
        date: "8 mei 2026",
        title: "Pull-to-refresh op je dashboard",
        items: [
            "Sleep omlaag op het dashboard om te vernieuwen.",
            "Forceert ook nieuwe app-versies — geen cache-issues meer.",
        ],
    },
    {
        version: "2.3.1",
        date: "8 mei 2026",
        title: "Strakkere Momentum-kaart",
        items: [
            "Geen lege ruimte meer onder Momentum.",
        ],
    },
    {
        version: "2.2.0",
        date: "8 mei 2026",
        title: "Momentum-uitleg in mensentaal",
        items: [
            "Tap het info-icoon voor uitleg in 30 seconden.",
        ],
    },
    {
        version: "2.1.0",
        date: "8 mei 2026",
        title: "Momentum komt tot leven",
        items: [
            "Score-orb krijgt een levendige glow.",
            "Mini grafiekje toont je weektrend.",
            "Score reageert op je richting.",
        ],
    },
    {
        version: "2.0.0",
        date: "8 mei 2026",
        title: "Momentum is nu de kern",
        items: [
            "Vijf duidelijke states met eigen kleur.",
            "Trendpijl naast je score.",
            "Tap voor 8-punts uitsplitsing.",
        ],
    },
    {
        version: "1.7.0",
        date: "8 mei 2026",
        title: "Lichte modus poetsen",
        items: [
            "Rings en Wheel passen netjes mee in lichte modus.",
        ],
    },
    {
        version: "1.6.0",
        date: "8 mei 2026",
        title: "Schoner zoeken naar voeding",
        items: [
            "Zoekresultaten met strakke iconen i.p.v. wisselende foto's.",
        ],
    },
    {
        version: "1.5.0",
        date: "8 mei 2026",
        title: "Premium Activity Rings",
        items: [
            "Schone ring-look zonder randen of pijltjes.",
            "Heldere positie-indicator op elke ring.",
        ],
    },
    {
        version: "1.4.0",
        date: "8 mei 2026",
        title: "Soepelere mobiele ervaring",
        items: [
            "Onboarding-vragen blijven zichtbaar tijdens typen.",
            "Tap een ring om iconen of rondes te tonen.",
        ],
    },
    {
        version: "1.3.0",
        date: "5 mei 2026",
        title: "Slimmere AI Coach",
        items: [
            "Persoonlijker en meer to-the-point.",
            "Inloggen met code per mail.",
            "Download al je data als PDF.",
        ],
    },
    {
        version: "1.2.0",
        date: "1 mei 2026",
        title: "Wheel of Momentum",
        items: [
            "Premium beloningswiel met goldglow.",
            "Naadloze Apple Health-sync.",
        ],
    },
];
